import React, { useRef, useState, useEffect } from 'react';
import { Button, Text, ColorPicker, Select, MediaDialog, InputHTML, Input, Slider } from 'ui';
import "./index.css";
import { darkBlue, pink, lightBlue } from 'config/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faCaretSquareLeft, faCaretSquareRight, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import buildExperience from './buildExperience';

export default function(props) {
  
  const frameRef = useRef();
  
  
  // Manage the currently active screen.
  
  const [active, setActive] = useState(0);
  function prev() {
    if(frameRef.current.contentWindow.experienceScreen) {
      let s = frameRef.current.contentWindow.experienceScreen(active - 1);
      setActive(s);
    }
  }
  function next() {
    if(frameRef.current.contentWindow.experienceScreen) {
      let s = frameRef.current.contentWindow.experienceScreen(active + 1);
      setActive(s);
    }
  }
  
  
  // Manage the template data. 
  
  const [tpl, setTpl] = useState(props.experience.tpl || []);
  
  useEffect(() => {
    if(!frameRef.current) {
      return;
    }
    let html = buildExperience(props.title || "Taptivate Experience", tpl, active);
    let doc = frameRef.current.contentWindow.document;
    doc.open();
    doc.write(html);
    doc.close();
  }, [tpl, frameRef, props.title]); // eslint-disable-line 
  
  // Note: ignoring `active` in useEffect dependencies because we don't want to 
  // refresh the HTML when the active screen changes. 
  
  
  function addScreen() {
    setTpl([...tpl, {transition:'fade', backgroundColor:"#ffffff"}]);
  }
  
  function removeScreen(i) {
    const tmp = [...tpl];
    tmp.splice(i, 1);
    setTpl(tmp);
  }
  
  function updateScreen(i, update) {
    let s = {...tpl[i], ...update};
    let t = [...tpl];
    t.splice(i, 1, s);
    setTpl(t);
  }
  
  function moveScreenUp(i) {
    
  } 
  
  function moveScreenDown(i) {
    
  } 
  
  const [isMediaDialogOpen, setMediaDialogOpen] = useState(false);
  const [mediaDialogField, setMediaDialogField] = useState(null);
  
  function chooseBackground(i) {
    setMediaDialogField(`${i}.backgroundImage`);
    setMediaDialogOpen(true);
  }
  
  function chooseImage(i) {
    setMediaDialogField(`${i}.image`);
    setMediaDialogOpen(true);
  }
  
  function selectMedia(url) {
    const t = [...tpl];
    _.set(t, mediaDialogField, url);
    setTpl(t);
    setMediaDialogOpen(false);
  }
  
  
  
  // Emit save
  
  function save() {
    let html = buildExperience(props.title || "Taptivate Experience", tpl);
    props.onSave({html, tpl});
  }
  
  
  
  // Render
  
  return (
    <div className="experienceeditor">
      
      {/* 
      Left side of the editor shows a phone preview.
      Should be 375x667px .
      Has a title and a button to trigger `onChangeType`.
      */}
      
      <div className="experienceeditor-left">
        
        <div className="experienceeditor-left-header">
          <Text block style={{flex:1}} bold large color={darkBlue}>{props.experience.name || ""}</Text>
          {props.onChangeType && 
            <Button onClick={props.onChangeType} backgroundColor={pink}>
              <svg width="24" height="24" viewBox="0 0 24 24" style={{fill:'white', marginRight:8}}>
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
              </svg>
              <Text white>Code Your Own</Text>
            </Button>
          }
        </div>
        
        <div className="experienceeditor-left-body">
          <Button onClick={prev}><FontAwesomeIcon size="3x" icon={faCaretSquareLeft}/></Button>
          <iframe title="preview" width="375" height="667" ref={frameRef} style={{backgroundColor:'black', border:0}}/>
          <Button onClick={next}><FontAwesomeIcon size="3x" icon={faCaretSquareRight}/></Button>
        </div>
        
      </div>
      
      
      <div className="experienceeditor-right">
        
        <div className="experienceeditor-right-body">
        
          {tpl.map((screen, i) => 
            <div key={i}>
              {i > 0 && 
                <Select 
                  style={{width:150, margin: "8px auto"}}
                  options={[
                    {label:'Fade to', value:'fade'}, 
                    {label:'Push to', value:'push'}, 
                    {label:'Flip to', value:'cube'}, 
                    {label:'Overlay to', value:'overlay'}
                  ]}
                  onChange={transition => updateScreen(i, {transition})}
                  value={screen.transition}
                />
              }
              <div key={i} className="experienceditor-screen" style={{backgroundColor: i === active ? "#bddce5" : "#e3e5e4"}}>
                <div className="experienceeditor-screen-header">
                  <Select 
                    style={{width:150, margin: "8px auto"}}
                    options={[
                      {label:'Screen', value:'screen'},
                    ]}
                    value="screen"
                    onChange={()=>null}
                  />
                  <div style={{flex:1}}/>
                  <Button onClick={() => moveScreenUp(i)}><FontAwesomeIcon icon={faCaretUp} size="2x"/></Button>
                  <Button onClick={() => moveScreenDown(i)}><FontAwesomeIcon icon={faCaretDown} size="2x"/></Button>
                  <Button onClick={() => removeScreen(i)}><FontAwesomeIcon icon={faTrash}/></Button>
                </div>
                
                <div className="experienceeditor-screen-sections">
                  
                  
                  
                  {/* Background */}
                  
                  <div className="experienceeditor-screen-section">
                    <Text block bold style={{marginBottom:16}}>Choose a Background</Text>
                    <ColorPicker
                      color={screen.backgroundColor}
                      onChange={backgroundColor => updateScreen(i, {backgroundColor:backgroundColor.hex})}
                      onChangeComplete={backgroundColor => updateScreen(i, {backgroundColor:backgroundColor.hex})}
                      pointer={
                        () => <div 
                          style={{
                            width: 24,
                            height: 24,
                            transform: 'translate(-12px, -6px)',
                            borderRadius: 12,
                            backgroundColor: screen.backgroundColor,
                            boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                          }}
                        />
                      }
                    />
                    <Text small block style={{padding:"16px 0 8px 0"}}>or use background Image</Text>
                    {screen.backgroundImage ? (
                      <div>
                        <Button label="Replace" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => chooseBackground(i)}/>
                        <Button label="Remove" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)'}} onClick={() => updateScreen(i, {backgroundImage:null})}/>
                      </div>
                    ) : (
                      <Button label="Choose Image" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => chooseBackground(i)}/>
                    )}
                  </div>
                
                
                
                  {/* Image */}
                
                  <div className="experienceeditor-screen-section">
                    <Text block bold style={{marginBottom:16}}>Choose an Image</Text>
                    
                    {screen.image ? (
                      <div>
                        <Button label="Replace" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => chooseImage(i)}/>
                        <Button label="Remove" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)'}} onClick={() => updateScreen(i, {image:null})}/>
                      </div>
                    ) : (
                      <Button label="Choose Image" backgroundColor="white" style={{boxShadow: '0 1px 2px rgba(0,0,0,0.3)', marginRight:8}} onClick={() => chooseImage(i)}/>
                    )}
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Position</Text>
                    <Select 
                      options={[
                        {label:'Top', value:'pos-top'},
                        {label:'Auto', value:''},
                        {label:'Bottom', value:'pos-bottom'},
                      ]}
                      value={screen.imagePosition || ''}
                      onChange={value => updateScreen(i, {imagePosition:value})}
                    />
                  </div>
                  
                  
                  {/* Message */}
                  
                  <div className="experienceeditor-screen-section">
                    <Text block bold style={{marginBottom:16}}>Show a Message</Text>
                    
                    <InputHTML value={screen.message} onChange={message => updateScreen(i, {message})}/>
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Font Size</Text>
                    <Slider
                      value={(screen.messageSize || 70) / 150}
                      onChange={mult => updateScreen(i, {messageSize: mult * 150})}
                    />
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Color</Text>
                    <ColorPicker
                      color={screen.messageColor || "#000000"}
                      onChange={messageColor => updateScreen(i, {messageColor:messageColor.hex})}
                      onChangeComplete={messageColor => updateScreen(i, {messageColor:messageColor.hex})}
                      pointer={
                        () => <div 
                          style={{
                            width: 24,
                            height: 24,
                            transform: 'translate(-12px, -6px)',
                            borderRadius: 12,
                            backgroundColor: screen.messageColor || "#000000",
                            boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                          }}
                        />
                      }
                    />
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Align</Text>
                    <Select 
                      options={[
                        {label:'Left', value:'align-left'},
                        {label:'Center', value:'align-center'},
                        {label:'Right', value:'align-right'},
                      ]}
                      value={screen.messageAlign || 'align-left'}
                      onChange={value => updateScreen(i, {messageAlign:value})}
                    />
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Position</Text>
                    <Select 
                      options={[
                        {label:'Top', value:'pos-top'},
                        {label:'Auto', value:''},
                        {label:'Bottom', value:'pos-bottom'},
                      ]}
                      value={screen.messagePosition || ''}
                      onChange={value => updateScreen(i, {messagePosition:value})}
                    />
                  </div>
                  
                  
                  {/* CTA */}
                  
                  <div className="experienceeditor-screen-section">
                    <Text block bold style={{marginBottom:16}}>Call to Action</Text>
                    
                    <Input placeholder="Label" onChange={ctaLabel => updateScreen(i, {ctaLabel})} style={{marginBottom:8}}/>
                    <Input placeholder="URL" onChange={ctaUrl => updateScreen(i, {ctaUrl})}/>
                    <Text small block style={{padding:"16px 0 8px 0"}}>Font Size</Text>
                    <Slider
                      value={(screen.ctaFontSize || 70) / 150}
                      onChange={mult => updateScreen(i, {ctaFontSize: mult * 70})}
                    />
                    <Text small block style={{padding:"16px 0 8px 0"}}>Color</Text>
                    <ColorPicker
                      color={screen.ctaColor || "#ffffff"}
                      onChange={ctaColor => updateScreen(i, {ctaColor:ctaColor.hex})}
                      onChangeComplete={ctaColor => updateScreen(i, {ctaColor:ctaColor.hex})}
                      pointer={
                        () => <div 
                          style={{
                            width: 24,
                            height: 24,
                            transform: 'translate(-12px, -6px)',
                            borderRadius: 12,
                            backgroundColor: screen.ctaColor || "#ffffff",
                            boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                          }}
                        />
                      }
                    />
                    <Text small block style={{padding:"16px 0 8px 0"}}>Background Color</Text>
                    <ColorPicker
                      color={screen.ctaBackgroundColor || "#fc511e"}
                      onChange={c => updateScreen(i, {ctaBackgroundColor:c.hex})}
                      onChangeComplete={c => updateScreen(i, {ctaBackgroundColor:c.hex})}
                      pointer={
                        () => <div 
                          style={{
                            width: 24,
                            height: 24,
                            transform: 'translate(-12px, -6px)',
                            borderRadius: 12,
                            backgroundColor: screen.ctaBackgroundColor || "#fc511e",
                            boxShadow: "0 2px 2px rgba(0,0,0,0.3)",
                          }}
                        />
                      }
                    />
                    
                    <Text small block style={{padding:"16px 0 8px 0"}}>Position</Text>
                    <Select 
                      options={[
                        {label:'Top', value:'pos-top'},
                        {label:'Auto', value:''},
                        {label:'Bottom', value:'pos-bottom'},
                      ]}
                      value={screen.ctaPosition || ''}
                      onChange={value => updateScreen(i, {ctaPosition:value})}
                    />
                  </div>
                  
                  
                </div>
              </div>
            </div>
          )}
        
          <Button label="Add Screen" color="white" backgroundColor={lightBlue} onClick={addScreen} style={{marginTop:24}}/>
        
        </div>
        <div className="experienceeditor-save">
          <Button label="SAVE & CLOSE" small white onClick={save}/>
        </div>
      </div>
      
      <MediaDialog 
        open={isMediaDialogOpen} 
        onRequestClose={() => setMediaDialogOpen(false)} 
        media={props.media}
        onSelect={selectMedia}
      />
    </div>
  );
}